import * as React from 'react';
import Tag from 'src/view/op-tag';
export default function Name(props) {
    const { value = '', record } = props;
    const { tagList = [], snList = [] } = record;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'name-wrap' }, value),
        tagList?.length ? (React.createElement("div", { className: 'tag-list' }, tagList.map((tag) => (React.createElement(Tag, { ...tag }))))) : null,
        snList && snList.length ? (React.createElement("div", { className: 'sn-list' },
            "sn: ",
            snList?.toString())) : null));
}
